import { StringUtils, engineComponent } from "neo-common";
import { Style } from "./Style";
import { ComponentTypes } from "../../ComponentTypes";

/**
 * The animation style is used for defined behaviour animation from sprite sheet.
 * Example:
 *   <ShapeStyle Class="ShapeStyle" ... />
 * @class ShapeStyle
 * @extends Style
 */
@engineComponent(ComponentTypes.Style)
export class ShapeStyle extends Style {
    lineWidth: number;

    // for InsideAnimationElement
    node: Element;

    constructor() {
        super();
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @return void
     */
    create(node: Element): void {
        super.create(node);

        /**
         * Store node for InsideAnimationElement
         *
         * todo Toto sa pouziva?
         * @type {Element}
         */
        this.node = node;

        if (node.hasAttribute(ShapeStyleAttributes.LINE_WIDTH)) {
            this.lineWidth = parseInt(node.getAttribute(ShapeStyleAttributes.LINE_WIDTH));
        }
    }
}

const ShapeStyleAttributes = {
    LINE_WIDTH: "LineWidth",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Elements/Styles/ShapeStyle.ts
 **/